<div
  class="bg-white shadow-lg py-5 rounded-2xl"
  [tooltip]="
    disabled()
      ? 'Discount codes are not available while the selected upgrade is active'
      : ''
  "
  placement="top"
  triggers="mouseenter:mouseleave">
  <div class="px-5">
    @if (hasDiscount) {
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <span
            class="font-bold text-[#535353]"
            data-cy="discount-code-applied">
            Code: {{ appliedCode }}
          </span>
        </div>
        <button
          type="button"
          data-cy="remove-discount-code-button"
          class="text-red-500 hover:text-red-700 font-bold text-xl leading-none"
          [disabled]="isLoading()"
          (click)="remove()"
          aria-label="Remove discount code">
          &times;
        </button>
      </div>
    } @else {
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">
          Discount Code
        </label>
        <div class="flex gap-2">
          <input
            type="text"
            data-cy="discount-code-input"
            class="min-w-0 flex-1 rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
            placeholder="Enter code"
            [(ngModel)]="code"
            [disabled]="isLoading() || disabled()"
            (keyup.enter)="apply()" />
          <button
            type="button"
            data-cy="apply-discount-code-button"
            class="shrink-0 whitespace-nowrap bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium hover:scale-95 transition-transform disabled:opacity-50 disabled:hover:transform-none"
            [disabled]="isLoading() || !code().trim() || disabled()"
            (click)="apply()">
            @if (isLoading()) {
              Applying...
            } @else {
              Apply
            }
          </button>
        </div>
      </div>
    }

    @if (errorMessage(); as msg) {
      <p class="mt-2 text-sm text-red-600" data-cy="discount-code-error">
        {{ msg }}
      </p>
    }
  </div>
</div>
